<template>
    <div class="cz__placement-header">
        {{placementName}}
    </div>

    <div v-for="group in optionGroups" :key="group.description" class="cz__groups">
        <!--<div class="cz__group-description">
            {{group.description.definition}}
        </div>-->

        <template v-if="group.description.definition.startsWith('Gem Color')">
            <div class="mt-10">
                <template v-for="cat in byCategory(group.options)" :key="cat[0]">
                    <div class="cz__category">
                        {{cat[0]}}
                    </div>

                    <div class="cz__group-options">
                        <template v-for="option in cat[1]" :key="option.value">
                            <button v-if="option.raw.option.custom?.['widget-type'] === 'color-swatch'"
                                class="cz__option-swatch"
                                :class="{
                                    'cz__option-swatch--selected': option.selected,
                                }"
                                @click.prevent="selectOption(option)"
                            >
                                <span class="cz__option-swatch__color"
                                    :style="{
                                        backgroundColor: '#' + option.raw.option.custom?.['hex'],
                                        backgroundImage: `url(https:${option.raw.option.custom?.['pattern-image']})`,
                                    }"
                                ></span>
                            </button>
                        </template>
                    </div>
                </template>
            </div>
        </template>
        <template v-else-if="group.description.definition.startsWith('Gem Dimensions')">
            <template v-for="option in group.options" :key="option.value">
                <button class="cz__option-button"
                    :class="{
                        'cz__option-button--selected': option.selected,
                    }"
                    @click.prevent="selectOption(option)"
                >
                    {{option.label}}
                </button>
            </template>
        </template>
        <template v-else-if="group.description.definition.startsWith('Gem Cut')">
            <template v-for="option in group.options" :key="option.value">
                <button class="cz__option-button"
                    :class="{
                        'cz__option-button--selected': option.selected,
                    }"
                    @click.prevent="selectOption(option)"
                >
                    {{option.label}}
                </button>
            </template>
        </template>
        <template v-else>
            <div class="cz__group-options">
                <template v-for="option in group.options" :key="option.value">
                    <button v-if="option.raw.option.custom?.['widget-type'] === 'color-swatch'"
                        class="cz__option-swatch"
                        :class="{
                            'cz__option-swatch--selected': option.selected,
                        }"
                        @click.prevent="selectOption(option)"
                    >
                        <span class="cz__option-swatch__color"
                            :style="{
                                backgroundColor: '#' + option.raw.option.custom?.['hex'],
                            }"
                        ></span>
                    </button>
                    <button v-else class="cz__option-button"
                        :class="{
                            'cz__option-button--oos': isOos(option),
                            'cz__option-button--selected': option.selected,
                        }"
                        @click.prevent="selectOption(option)"
                    >
                        {{option.label}}
                    </button>
                </template>
            </div>
        </template>
    </div>
</template>

<style lang="scss">
    #cz3 {
        .cz__placement-header {
            position: relative;

            margin-bottom: 10px;

            text-transform: uppercase;

            font-weight: 700;
            font-size: 18px;

            &:before {
                content: '';

                position: absolute;

                left: 0;
                top: -20px;
                right: 0px;
                height: 1px;

                background: #DFDEDD;
            }
        }

        .cz__group-options + .cz__category {
            margin-top: 15px;
        }

        .cz__groups {
            margin-bottom: 15px;
        }

        .cz__placement {
            margin-bottom: 45px;
        }

        .cz__group-options {
            display: flex;

            justify-content: flex-start;
            align-items: center;

            flex-wrap: wrap;
            gap: 10px;
        }

        .cz__option-button {
            padding: 10px;
            padding-top: 10px;
            padding-bottom: 5px;

            line-height: 1;
            border: 2px solid #333;

            &.cz__option-button--selected {
                border: 2px solid #333;
                background: #333;
                color: #fff;
            }

            transition: all 0.25s ease-out;
        }

        .cz__option-swatch {
            display: inline-block;

            width: 60px;
            height: 60px;

            border-radius: 60px;

            border: 2px solid #eee;

            &.cz__option-swatch--selected {
                border: 2px solid #333;

                .cz__option-swatch__color {
                    position: absolute;

                    left: 6px;
                    top: 6px;
                    right: 6px;
                    bottom: 6px;

                    border-radius: 60px;
                }
            }

            position: relative;

            .cz__option-swatch__color {
                position: absolute;

                left: 3px;
                top: 3px;
                right: 3px;
                bottom: 3px;

                border-radius: 60px;

                transition: all 0.25s ease-out;

                background-size: contain;
                background-position: center;
                background-repeat: no-repeat;
            }

            transition: all 0.25s ease-out;
        }

        .cz__option-button--oos {
            position: relative;

            opacity: 0.25;
        }
    }
</style>

<script>
    import allStores from '../stores/all';

    export default {
        mixins: [allStores],

        props: {
            placement: Object,
        },

        data() {
            return {
                showIndividualOptions: false,
            };
        },

        components: {
        },

        computed: {
            viewController() {
                return this.customizerStore.viewController;
            },

            /**
             * Within each placement, create groups based on individual component definitions.
             */
            optionGroups() {
                const placementGroups = this.viewController.groupByDefinitions(this.placement, {
                    includeUnavailable: true,
                });

                // eslint-disable-next-line arrow-body-style
                const niceGroups = placementGroups.map((group) => ({
                    description: group.description,
                    options: group.options.filter((o) => !o.placeholder).map((o) => ({
                        hidden: o.hidden,
                        available: o.available,
                        allowed: o.allowed,
                        selected: o.selected,
                        value: o.option.code,
                        label: o.option.name,
                        definition: o.option.definition,
                        raw: o,
                    })),
                    selectedValue: group.options.find((o) => o.selected)?.option?.code || '',
                }));

                // if (!this.showIndividualOptions) {
                //     return groups.length > 0 ? groups.slice(0, 1) : [];
                // }

                return niceGroups;
            },

            useSame() {
                return this.viewController.selectedAtPlacement('GemConfiguration').placementIndependentCode === 'GEMSSAME';
            },

            placementName() {
                if (this.placement.name === 'Gem 1') {
                    const useSame = this.viewController.selectedAtPlacement('GemConfiguration').placementIndependentCode === 'GEMSSAME';

                    if (useSame) {
                        return 'Gems - Apply to All Placements';
                    }
                }

                return this.placement.name;
            },
        },

        methods: {
            selectOption(option) {
                if (this.useSame && this.placement.code.startsWith('Gem0')) {
                    this.viewController.state.map((x) => x.placement.code).filter((x) => /Gem\d\d/.test(x)).forEach((code) => {
                        this.viewController.updateSimilarComponent(code, option.definition, option.value);
                    });
                } else {
                    this.viewController.updateSimilarComponent(this.placement.code, option.definition, option.value);
                }
            },

            isOos(option) {
                // eslint-disable-next-line
                console.log('!!!!!!!!!!11', this.placement.code, option.value);
                const sku = [];

                this.viewController.state.forEach((s) => {
                    if (s.placement.custom?.['baa-sku'] === 'true') {
                        if (s.placement.code === this.placement.code) {
                            sku.push(option.value);
                        } else {
                            sku.push(s.component.placementIndependentCode);
                        }
                    }
                });

                const code = sku.join('-');

                const variant = this.customizerStore.variants.find((x) => x.sku === code);

                if (variant && variant.ats === 0) {
                    return true;
                }

                return false;
            },

            byCategory(options) {
                const list = {};

                options.forEach((o) => {
                    const category = o.raw.option.custom?.category;

                    if (list[category] == null) {
                        list[category] = [];
                    }

                    list[category].push(o);
                });

                return Object.entries(list);
            },
        },
    };
</script>
